<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    multiple
    placeholder="All"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  ConnectionType,
  ConnectionTypeLabel,
  ConnectionTypeLabels
} from '@/api/types'

type ConnectionEntry = {
  key: ConnectionType
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'ConnectionTypeSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = ConnectionTypeLabels.map<ConnectionEntry>(
      (connectionLabel: ConnectionTypeLabel) => {
        return {
          key: connectionLabel.type_id,
          label: connectionLabel.label,
          disabled: false
        }
      }
    )

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    function update(newValue: Array<ConnectionType>) {
      context.emit('update:modelValue', newValue)
    }

    return { options, update, value }
  }
})
</script>
